'use client';
import { createQuery, Refresh } from '@s7/query';
import { compileTemplate } from '../../../common/compileTemplate/compileTemplate.js';

const useSearchQuery = createQuery(({ url, query })=>({
        query: compileTemplate(url, {
            limit: 10,
            lang: 'ru',
            query
        }),
        refresh: Refresh.Never
    }));

export { useSearchQuery };
//# sourceMappingURL=Search.js.map
